<template>
	<div class="home-container fade-in">
		<el-carousel :interval="5000" arrow="always" height="6.8rem">
			<el-carousel-item v-for="item in banner" :key="item.id">
				<img :src="item.img" class="carousel-image" @click="naviToBannerDetails(item)">
			</el-carousel-item>
		</el-carousel>
		<div class="titleBox">
			<div class="title">3D鞋壳数字资源作品</div>
			<div class="subTitle">资产种类繁多，满足各种各样的需求。</div>
		</div>
		<div class="areaBox">
			<div class="areaItem" @click="$router.push('/works-list?type=2')">
				<img class="areaIcon" :src="modelZone" v-if="modelZone" />
				资源整合专区
			</div>
			<div class="areaItem" @click="$router.push('/works-list?type=1')">
				<img class="areaIcon" :src="materialZone" v-if="materialZone" />
				2D3D数字材质
			</div>
		</div>
		<div class="titleBox">
			<div class="title">热门材质推荐</div>
			<div class="subTitle">资产种类繁多，满足各种各样的需求。</div>
		</div>
		<div class="orderListBox">
			<div class="orderList" v-if="materialData.length">
				<div class="orderItem" v-for="(item,index) in materialData" :key="index"
					@click="goodsId = item.id;isBuy = item.is_buy;workDetailsShow = true">
					<img class="orderImg" :src="item.img" />
					<div class="orderName">{{item.title}}</div>
				</div>
			</div>
			<div class="more" @click="$router.push('/popular-recommend?type=1')">查看更多</div>
		</div>
		<div class="titleBox">
			<div class="title">热门模型推荐</div>
			<div class="subTitle">资产种类繁多，满足各种各样的需求。</div>
		</div>
		<div class="orderListBox">
			<div class="orderList" v-if="modelData.length">
				<div class="orderItem" v-for="(item,index) in modelData" :key="index"
					@click="goodsId = item.id;isBuy = item.is_buy;workDetailsShow = true">
					<img class="orderImg" :src="item.img" />
					<div class="orderName">{{item.title}}</div>
				</div>
			</div>
			<div class="more" @click="$router.push('/popular-recommend?type=2')">查看更多</div>
		</div>
		<WorkDetailsDialog :show="workDetailsShow" :goodsId="goodsId" :isBuy="isBuy" @close="workDetailsShow = false"
			@exchangeSuc="sucPop = true" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'您已完成作品兑换，可到个人中心'" :descTwo="'我的作品模块查看'"
			@clickOk="sucPop = false;$router.push('/personal-center?menuId=3')" v-if="sucPop" />
	</div>
</template>

<script>
	import WorkDetailsDialog from '../components/WorkDetailsDialog.vue'
	export default {
		name: 'HomePage',
		components: {
			WorkDetailsDialog
		},
		data() {
			return {
				sucPop: false,
				modelZone: '',
				materialZone: '',
				modelData: [],
				materialData: [],
				token: '',
				banner: [], //轮播图
				goodsId: '',
				isBuy: 0,
				workDetailsShow: false,
				rankTitleData: ['新锐榜', '实力榜', '勤奋榜']
			}
		},
		mounted() {
			this.token = localStorage.getItem('token')
			this.getBanner()
			this.configData()
			this.headerGoodsList()
		},
		methods: {
			//跳转Banner详情
			naviToBannerDetails(item) {
				if (!item.mb_id) return
				window.open(item.mb_id, '_blank');
			},
			//获取轮播图
			getBanner() {
				this.$api.post('/Other/banner', {}).then(res => {
					if (res.code == 1) {
						this.banner = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//顶部两张示例图
			configData() {
				this.$api.post('/Other/config', {}).then(res => {
					if (res.code == 1) {
						res.data.forEach(item => {
							if (item.title == 'cz_img') {
								this.materialZone = item.value
							}
							if (item.title == 'mx_img') {
								this.modelZone = item.value
							}
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//首页作品
			headerGoodsList() {
				this.$api.post('/Goods/top_goods_list', {
					p: 1,
					type: 1,
					pagesize: 8,
					user_id: localStorage.getItem('userId') ? localStorage.getItem('userId') : '',
				}).then(res => {
					if (res.code == 1) {
						this.materialData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
				this.$api.post('/Goods/top_goods_list', {
					p: 1,
					type: 2,
					pagesize: 8,
					user_id: localStorage.getItem('userId') ? localStorage.getItem('userId') : '',
				}).then(res => {
					if (res.code == 1) {
						this.modelData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.home-container {
		background: rgba(8, 8, 8, 1);
		padding-bottom: .4rem;
	}

	::v-deep .el-carousel__button {
		width: .5rem !important;
		height: .04rem !important;
	}

	@media (max-width: 480px) {
		.titleBox {
			margin: .16rem auto 0;
			width: 12rem;
			display: flex;
			flex-direction: column;

			.title {
				font-weight: 500;
				font-size: .56rem;
				color: #FFFFFF;
				line-height: .8rem;
			}

			.subTitle {
				margin-top: .24rem;
				font-weight: 400;
				font-size: .36rem;
				color: #FFFFFF;
				line-height: .48rem;
			}
		}

		.areaBox {
			margin: .4rem auto 0;
			width: 12rem;
			display: flex;
			flex-direction: column;

			.areaItem {
				display: flex;
				align-items: center;
				flex-direction: column;
				margin-bottom: .48rem;
				font-size: .48rem;
				color: #FFFFFF;
				cursor: pointer;

				.areaIcon {
					margin-bottom: .64rem;
					height: 6.4rem;
					width: 11.6rem;
					border-radius: .16rem;
					object-fit: cover;
				}
			}
		}

		.orderListBox {
			margin: 0 auto;
			display: flex;
			align-items: center;
			flex-direction: column;
			width: 12rem;

			.more {
				margin-top: .8rem;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 2.4rem;
				height: 1rem;
				background: #1673E6;
				border-radius: .5rem;
				backdrop-filter: blur(2px);
				font-weight: 400;
				font-size: .36rem;
				color: #FFFFFF;
				line-height: .52rem;
				cursor: pointer;
			}

			.orderList {
				width: 100%;
				display: flex;
				flex-wrap: wrap;

				.orderItem:nth-child(2n) {
					margin-right: 0;
				}

				.orderItem {
					margin-top: .8rem;
					margin-right: .48rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;

					.orderImg {
						width: 5.64rem;
						height: 5.64rem;
						border-radius: .16rem;
						object-fit: cover;
					}

					.orderName {
						margin-top: .56rem;
						width: 5.64rem;
						font-weight: 500;
						font-size: .36rem;
						color: #FFFFFF;
						line-height: .5rem;
					}

					.collection {
						margin-top: .48rem;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 3.76rem;
						height: .72rem;
						background: #1673E6;
						border-radius: .36rem;
						font-weight: 400;
						font-size: .28rem;
						color: #FFFFFF;
						line-height: .4rem;

						.collectionIcon {
							margin-right: .08rem;
							width: .28rem;
							height: .28rem;
						}
					}
				}
			}
		}
	}

	@media (min-width: 481px) {
		.titleBox {
			margin: .8rem auto 0;
			width: 12rem;
			display: flex;
			flex-direction: column;

			.title {
				font-weight: 500;
				font-size: .28rem;
				color: #FFFFFF;
				line-height: .4rem;
			}

			.subTitle {
				margin-top: .12rem;
				font-weight: 400;
				font-size: .18rem;
				color: #FFFFFF;
				line-height: .24rem;
			}
		}

		.areaBox {
			margin: .4rem auto 0;
			width: 12rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.areaItem {
				display: flex;
				align-items: center;
				flex-direction: column;
				font-size: .24rem;
				color: #FFFFFF;
				cursor: pointer;

				.areaIcon {
					margin-bottom: .32rem;
					height: 3.2rem;
					width: 5.8rem;
					border-radius: .08rem;
					object-fit: cover;
				}
			}
		}

		.orderListBox {
			margin: 0 auto;
			display: flex;
			align-items: center;
			flex-direction: column;
			width: 12rem;

			.more {
				margin-top: .4rem;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 1.2rem;
				height: .5rem;
				background: #1673E6;
				border-radius: .25rem;
				backdrop-filter: blur(2px);
				font-weight: 400;
				font-size: .18rem;
				color: #FFFFFF;
				line-height: .26rem;
				cursor: pointer;
			}

			.orderList {
				width: 100%;
				display: flex;
				flex-wrap: wrap;

				.orderItem:nth-child(4n) {
					margin-right: 0;
				}

				.orderItem {
					margin-top: .4rem;
					margin-right: .24rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;

					.orderImg {
						width: 2.82rem;
						height: 2.82rem;
						border-radius: .08rem;
						object-fit: cover;
					}

					.orderName {
						margin-top: .28rem;
						width: 2.82rem;
						font-weight: 500;
						font-size: .18rem;
						color: #FFFFFF;
						line-height: .25rem;
					}

					.collection {
						margin-top: .24rem;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 1.88rem;
						height: .36rem;
						background: #1673E6;
						border-radius: .18rem;
						font-weight: 400;
						font-size: .14rem;
						color: #FFFFFF;
						line-height: .2rem;

						.collectionIcon {
							margin-right: .04rem;
							width: .14rem;
							height: .14rem;
						}
					}
				}
			}
		}
	}

	.carousel-image {
		width: 100%;
		height: 6.8rem;
		object-fit: cover;
		cursor: pointer;
	}
</style>